export default "__VITE_ASSET__BmG_euwS__"